export default "__VITE_ASSET__Bap7hi8O__"